const SurveyStatusEnum = {
    1: {
        label: 'Satisfeito',
        color: '#45D256',
        key: 'SATISFIED',
    },
    2: {
        label: 'Insatisfeito',
        color: '#EB6878',
        key: 'UNSATISFIED',
    },
    3: {
        label: 'Pendente',
        color: '#F39C12',
        key: 'UNSATISFIED',
    },
    4: {
        label: 'Neutro',
        color: 'rgb(180, 180, 180)',
        key: 'NEUTRO',
    },
};
export default SurveyStatusEnum;
